"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSIGNATION_OFFER_CANCELLATION_REASONS = void 0;
exports.ASSIGNATION_OFFER_CANCELLATION_REASONS = {
    REPOSTED: "Offer reposting",
    MANUAL_CANCELLATION: "Offer was manually cancelled",
    ORDER_CANCELLED: "Order was cancelled",
    ASSIGNATION_CREATED: "Assignation created for a different offer",
    OFFER_DETAILS_CHANGED: "Offer details changed",
    ASSIGNATION_CANCELLED: "Assignation was cancelled",
    NEW_COMBO_CREATED: "New combo was created",
};
//# sourceMappingURL=assignationOfferCancellationReasons.js.map